import { initializeLanguageFromUser } from "@/i18n/config";
import { useLanguageStore } from "@/stores/preferences/language-store";

/**
 * Language Initializer Component
 *
 * This component watches for user data changes and initializes the language
 * from the user's preferences stored in the backend.
 */
export function LanguageInitializer() {
  //TODO get the language from the store when user data is available
  const { language } = useLanguageStore();

  initializeLanguageFromUser(language);

  // This component doesn't render anything
  return null;
}
